import { expandLocales, type Translate } from './localized';
import { getLang } from './i18n';
const labels = {
  fr: {
    consent: 'Envoyer mon dossier à Maison Mata',
    consentBody: 'J’accepte l’envoi privé de ma photo, de ma fiche PDF et de mes choix à Maison Mata pour préparer ma commande.',
    retention: (days: number) => `Un dossier sans commande sera supprimé après ${days} jours. Vous pouvez télécharger les fichiers sans les transmettre.`,
    confirm: 'Envoyer le dossier et ajouter au panier', cancel: 'Retour',
    unavailable: 'L’ajout au panier avec votre dossier est momentanément indisponible. Téléchargez votre photo et votre PDF pour les envoyer à Maison Mata.',
    changed: 'Vos choix ont changé. Vérifiez votre dossier puis réessayez.',
    sendBoth: 'Partager photo + PDF', downloadPhoto: 'Télécharger la photo',
    fallback: 'Téléchargez la photo ET le PDF, puis joignez les deux fichiers dans WhatsApp. Le message seul ne les contient pas.',
    waHelp: 'Dans la feuille de partage, choisissez WhatsApp et vérifiez les deux pièces jointes avant d’envoyer.',
    privacy: 'L’essayage reste sur votre appareil. La photo et le PDF sont transmis uniquement à votre demande.',
    sharePhoto: 'Partager la photo', preparing: 'Préparation de la photo et du PDF…', retry: 'Réessayer les exports',
  },
  en: {
    consent: 'Send my order files to Maison Mata',
    consentBody: 'I agree to privately send my photo, PDF and choices to Maison Mata to prepare my order.',
    retention: (days: number) => `Files without an order are deleted after ${days} days. You can download the files without sending them.`,
    confirm: 'Send files and add to cart', cancel: 'Back',
    unavailable: 'Cart orders with your files are temporarily unavailable. Download your photo and PDF to send them to Maison Mata.',
    changed: 'Your choices have changed. Review your files and try again.',
    sendBoth: 'Share photo + PDF', downloadPhoto: 'Download photo',
    fallback: 'Download BOTH the photo and PDF, then attach both files in WhatsApp. The message alone does not include them.',
    waHelp: 'Choose WhatsApp in the share sheet and check both attachments before sending.',
    privacy: 'Try-on stays on your device. The photo and PDF are sent only at your request.',
    sharePhoto: 'Share photo', preparing: 'Preparing photo and PDF…', retry: 'Retry exports',
  },
  id: {
    consent: 'Kirim berkas pesanan ke Maison Mata',
    consentBody: 'Saya menyetujui pengiriman pribadi foto, PDF dan pilihan saya ke Maison Mata untuk menyiapkan pesanan.',
    retention: (days: number) => `Berkas tanpa pesanan dihapus setelah ${days} hari. Anda dapat mengunduh berkas tanpa mengirimkannya.`,
    confirm: 'Kirim berkas dan tambah ke keranjang', cancel: 'Kembali',
    unavailable: 'Pesanan keranjang dengan berkas sementara tidak tersedia. Unduh foto dan PDF untuk dikirim ke Maison Mata.',
    changed: 'Pilihan Anda berubah. Periksa berkas dan coba lagi.',
    sendBoth: 'Bagikan foto + PDF', downloadPhoto: 'Unduh foto',
    fallback: 'Unduh foto DAN PDF, lalu lampirkan keduanya di WhatsApp. Pesan saja tidak menyertakan berkas.',
    waHelp: 'Pilih WhatsApp di lembar berbagi dan periksa kedua lampiran sebelum mengirim.',
    privacy: 'Coba virtual tetap di perangkat Anda. Foto dan PDF dikirim hanya atas permintaan Anda.',
    sharePhoto: 'Bagikan foto', preparing: 'Menyiapkan foto dan PDF…', retry: 'Coba ekspor lagi',
  },
};
export const a204words = () => ALL_LABELS[getLang()];

const ALL_LABELS = expandLocales(labels, (tr: Translate) => ({
    consent: tr("Send my order files to Maison Mata"),
    consentBody: tr("I agree to privately send my photo, PDF and choices to Maison Mata to prepare my order."),
    retention: (days: number) => tr("Files without an order are deleted after {0} days. You can download the files without sending them.", [days]),
    confirm: tr("Send files and add to cart"), cancel: tr("Back"),
    unavailable: tr("Cart orders with your files are temporarily unavailable. Download your photo and PDF to send them to Maison Mata."),
    changed: tr("Your choices have changed. Review your files and try again."),
    sendBoth: tr("Share photo + PDF"), downloadPhoto: tr("Download photo"),
    fallback: tr("Download BOTH the photo and PDF, then attach both files in WhatsApp. The message alone does not include them."),
    waHelp: tr("Choose WhatsApp in the share sheet and check both attachments before sending."),
    privacy: tr("Try-on stays on your device. The photo and PDF are sent only at your request."),
    sharePhoto: tr("Share photo"), preparing: tr("Preparing photo and PDF\u2026"), retry: tr("Retry exports"),
}));
